// VbPagoBadge — insignia de estado del V°B° para Pago (Iter 413).
// autorizada (verde) / pendiente (ámbar) / no_aplica (gris).
import { ShieldCheck, Clock, MinusCircle } from 'lucide-react';

const STYLES = {
  autorizada: {
    cls: 'text-emerald-700 bg-emerald-50 border-emerald-200',
    icon: ShieldCheck,
    label: 'Autorizada',
  },
  pendiente: {
    cls: 'text-amber-700 bg-amber-50 border-amber-200',
    icon: Clock,
    label: 'Pendiente V°B°',
  },
  no_aplica: {
    cls: 'text-gray-500 bg-gray-50 border-gray-200',
    icon: MinusCircle,
    label: 'No aplica',
  },
};

export function VbPagoBadge({ estado, numeroOc }) {
  const st = STYLES[(estado || 'pendiente').toLowerCase()] || STYLES.pendiente;
  const Icon = st.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full border ${st.cls}`}
      data-testid={`vb-pago-badge-${numeroOc ?? 'x'}`}
    >
      <Icon className="w-3 h-3" /> {st.label}
    </span>
  );
}
